import { render } from "./SocialAccounts.vue?vue&type=template&id=b046b7b8&scoped=true"
import script from "./SocialAccounts.vue?vue&type=script&lang=js"
export * from "./SocialAccounts.vue?vue&type=script&lang=js"

import "./SocialAccounts.vue?vue&type=style&index=0&id=b046b7b8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kevin\\Documents\\GitHub\\my_page\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b046b7b8"]])

export default __exports__